import React from 'react';
import BaseListComponent from '../../../components/common/base-list.c';
import tpl from '../templates/business-list';
import {utmMarks} from '../../../../../utmMarks';

export default class BusinessList extends BaseListComponent {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            withUtmMarks: false
        };
        return this;
    }

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const hasUtm = utmMarks.some(mark => urlParams.has(mark));

        if (hasUtm) {
            this.setState({withUtmMarks: true});
        }
    }
}
